export default __webpack_public_path__ + "static/mask-image-dark-4bfa32d731cf6c3335a3848c2af93db6.png";